import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import React from 'react';
import { imageProxy } from 'tf-post-parser';

export default function Title({ title, excerpt, thumbnail }) {
  const useStyles = makeStyles()(() => ({
    bgContainer: {
      overflow: 'hidden',
      position: 'relative',
    },
    bg: {
      backgroundImage: thumbnail
        ? `linear-gradient(rgba(0, 0, 0, 0.1),rgba(0, 0, 0,0.5)),
        url("${imageProxy(thumbnail, undefined, 400, 'fit')}")`
        : undefined,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      minHeight: '50px',
      transition: 'all 0.5s',
      '&:hover': {
        transform: 'scale(1.3)',
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className="container" style={{ minWidth: 400 }}>
      <div className="row">
        {thumbnail && (
          <div
            className={`${classes.bgContainer} col-12 col-xl-4 col-lg-4 cl-md-4 col-sm-4 p-0`}
          >
            <div className={`${classes.bg} w-100 h-100`} />
          </div>
        )}
        <div
          className={`col-12 ${
            thumbnail ? 'col-xl-8 col-lg-8 cl-md-8 col-sm-8' : ''
          }`}
        >
          <Typography
            gutterBottom
            variant="body1"
            className="text-left p-0 font-weight-bold"
          >
            {title}
          </Typography>{' '}
          <Typography gutterBottom variant="subtitle2">
            {excerpt.substring(0, 100)}...
          </Typography>
        </div>
      </div>
    </div>
  );
}
